import React, { useState } from 'react';
import { createPortal } from 'react-dom'; // 🌟 ADDED THIS

const ShareModal = ({ isOpen, onClose, link = "localhost:3000/register/" }) => {
  const [copied, setCopied] = useState(false);

  if (!isOpen) return null;

  const handleCopy = () => {
    navigator.clipboard.writeText(link);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  // URL Encoded link for social intents
  const encodedLink = encodeURIComponent(link);
  const shareText = encodeURIComponent("Check out this link: ");

  const socialIntents = {
    whatsapp: `https://api.whatsapp.com/send?text=${shareText}${encodedLink}`,
    facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodedLink}`,
    linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${encodedLink}`,
    instagram: `https://www.instagram.com/` 
  };

  // 🌟 WRAPPED THE ENTIRE RETURN IN createPortal 🌟
  return createPortal(
    <div className="fixed inset-0 z-[100000] flex items-center justify-center bg-slate-900/60 backdrop-blur-sm p-4 sm:p-6">
      
      {/* 🌟 GUARANTEED BLOW-UP ANIMATION CSS 🌟 */}
      <style>{`
        @keyframes blowUp {
          0% { transform: scale(0.6); opacity: 0; }
          75% { transform: scale(1.03); opacity: 1; }
          100% { transform: scale(1); opacity: 1; }
        }
        .animate-blow-up {
          animation: blowUp 0.35s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards;
        }
      `}</style>

      {/* Modal Container with the custom animate-blow-up class */}
      <div className="animate-blow-up w-full max-w-[500px] bg-white dark:bg-[#1e1f22] rounded-md shadow-2xl border border-slate-200 dark:border-slate-700/50 overflow-hidden">
        
        {/* Header */}
        <div className="flex items-center justify-between p-5 pb-4">
          <h2 className="text-[22px] font-medium text-slate-900 dark:text-slate-100 tracking-tight">
            Shareable public link
          </h2>
          <button 
            onClick={onClose} 
            className="p-1.5 text-slate-400 hover:text-red-500 dark:hover:text-red-400 transition-colors rounded-sm"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" /></svg>
          </button>
        </div>

        {/* Body */}
        <div className="p-5 pt-2">
          
          {/* Link Input Box */}
          <div className="flex items-center justify-between bg-slate-100 dark:bg-[#2c2d31] rounded-md border border-slate-200 dark:border-slate-700/50 p-1.5 mb-5">
            <div className="overflow-hidden px-3">
              <p className="text-[15px] font-medium text-slate-700 dark:text-slate-300 truncate select-all underline decoration-slate-300 dark:decoration-slate-600 underline-offset-4">
                {link}
              </p>
            </div>
            
            <button
              onClick={handleCopy}
              className="flex-shrink-0 flex items-center gap-2 bg-[#d3e3fd] text-[#041e49] hover:bg-[#b9d3fa] dark:bg-[#a8c7fa] dark:text-[#062e6f] dark:hover:bg-[#93b8fa] px-5 py-2.5 rounded-md text-sm font-semibold transition-colors active:scale-95"
            >
              {copied ? (
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M5 13l4 4L19 7"/></svg>
              ) : (
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"/></svg>
              )}
              {copied ? 'Copied' : 'Copy link'}
            </button>
          </div>

          {/* Disclaimer */}
          <div className="flex gap-2.5 text-slate-500 dark:text-slate-400 mb-8">
            <svg className="w-4 h-4 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
            <p className="text-[13px] leading-relaxed">
              Public links can be reshared. Share <a href="#" className="text-blue-600 dark:text-[#a8c7fa] hover:underline font-medium">responsibly</a>, <a href="#" className="text-blue-600 dark:text-[#a8c7fa] hover:underline font-medium">delete</a> anytime. If sharing with third-parties, their policies apply.
            </p>
          </div>

          {/* Social Icons Row */}
          <div className="flex items-center justify-around pb-2">
            
            {/* WhatsApp */}
            <a href={socialIntents.whatsapp} target="_blank" rel="noopener noreferrer" className="flex flex-col items-center gap-2.5 group">
              <div className="w-[52px] h-[52px] rounded-full bg-[#25D366] text-white flex items-center justify-center transition-all duration-300 ease-out shadow-sm group-hover:scale-110 group-hover:-translate-y-1.5 group-hover:shadow-[0_8px_16px_rgba(37,211,102,0.3)]">
                <svg className="w-[26px] h-[26px]" fill="currentColor" viewBox="0 0 24 24"><path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.413 3.488 2.245 2.248 3.481 5.236 3.48 8.414-.003 6.557-5.338 11.892-11.893 11.892-1.99-.001-3.951-.5-5.688-1.448l-6.305 1.654zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884-.001 2.225.651 3.891 1.746 5.634l-.999 3.648 3.742-.981zm11.387-5.464c-.074-.124-.272-.198-.57-.323-.297-.124-1.758-.867-2.03-.967-.272-.099-.47-.149-.669.149-.198.297-.768.967-.941 1.165-.173.198-.347.223-.644.099-.297-.124-1.255-.462-2.39-1.287-.88-.643-1.473-1.439-1.646-1.737-.173-.297-.018-.458.13-.582.134-.111.297-.347.446-.52.151-.172.2-.296.3-.495.099-.198.05-.371-.025-.495-.075-.124-.669-1.611-.916-2.206-.242-.579-.487-.501-.669-.51l-.57-.01c-.198 0-.52.074-.792.347-.272.297-1.04 1.016-1.04 2.476 0 1.46 1.065 2.871 1.213 3.07.149.198 2.096 3.2 5.077 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.695.248-1.288.173-1.413z"/></svg>
              </div>
              <span className="text-[13px] font-medium text-slate-600 dark:text-slate-300 group-hover:text-slate-900 dark:group-hover:text-white transition-colors">WhatsApp</span>
            </a>

            {/* Instagram */}
            <a href={socialIntents.instagram} target="_blank" rel="noopener noreferrer" className="flex flex-col items-center gap-2.5 group">
              <div className="w-[52px] h-[52px] rounded-full bg-gradient-to-tr from-[#f09433] via-[#e6683c] to-[#bc1888] text-white flex items-center justify-center transition-all duration-300 ease-out shadow-sm group-hover:scale-110 group-hover:-translate-y-1.5 group-hover:shadow-[0_8px_16px_rgba(230,104,60,0.3)]">
                <svg className="w-7 h-7" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><rect x="2" y="2" width="20" height="20" rx="5" ry="5"/><path d="M16 11.37A4 4 0 1112.63 8 4 4 0 0116 11.37z"/><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"/></svg>
              </div>
              <span className="text-[13px] font-medium text-slate-600 dark:text-slate-300 group-hover:text-slate-900 dark:group-hover:text-white transition-colors">Instagram</span>
            </a>

            {/* Facebook */}
            <a href={socialIntents.facebook} target="_blank" rel="noopener noreferrer" className="flex flex-col items-center gap-2.5 group">
              <div className="w-[52px] h-[52px] rounded-full bg-[#1877f2] text-white flex items-center justify-center transition-all duration-300 ease-out shadow-sm group-hover:scale-110 group-hover:-translate-y-1.5 group-hover:shadow-[0_8px_16px_rgba(24,119,242,0.3)]">
                <svg className="w-7 h-7" fill="currentColor" viewBox="0 0 24 24"><path d="M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z"/></svg>
              </div>
              <span className="text-[13px] font-medium text-slate-600 dark:text-slate-300 group-hover:text-slate-900 dark:group-hover:text-white transition-colors">Facebook</span>
            </a>

            {/* LinkedIn */}
            <a href={socialIntents.linkedin} target="_blank" rel="noopener noreferrer" className="flex flex-col items-center gap-2.5 group">
              <div className="w-[52px] h-[52px] rounded-full bg-[#0077b5] text-white flex items-center justify-center transition-all duration-300 ease-out shadow-sm group-hover:scale-110 group-hover:-translate-y-1.5 group-hover:shadow-[0_8px_16px_rgba(0,119,181,0.3)]">
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24"><path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/></svg>
              </div>
              <span className="text-[13px] font-medium text-slate-600 dark:text-slate-300 group-hover:text-slate-900 dark:group-hover:text-white transition-colors">LinkedIn</span>
            </a>

          </div>
        </div>
      </div>
    </div>,
    document.body // 🌟 TELEPORTS MODAL TO THE ROOT LEVEL 🌟
  );
};

export default ShareModal;